import {
  HttpErrorResponse,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest
} from "@angular/common/http";
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AuthService } from "src/app/auth/auth.service";

export const HttpErrorInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  const _authService = inject(AuthService);
  const _router = inject(Router);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      console.log('error', error);

      if (error.status === 401) {
        localStorage.removeItem('ATID');
        _router.navigate(['/login']);
      }

      if (error.status === 403) {
        _router.navigate(['/']);
      }

      return throwError(error);
    }),
  );
};